import type { SVGProps } from 'react';

type IconProps = SVGProps<SVGSVGElement>;

const baseProps: SVGProps<SVGSVGElement> = {
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.6,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
};

export const HomeIcon = (props: IconProps) => (
  <svg {...baseProps} {...props}>
    <path d="M3 10l9-7 9 7v10a2 2 0 0 1-2 2h-4v-7h-6v7H5a2 2 0 0 1-2-2z" />
  </svg>
);

export const BookIcon = (props: IconProps) => (
  <svg {...baseProps} {...props}>
    <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20V3H6.5A2.5 2.5 0 0 0 4 5.5z" />
    <path d="M4 19.5V21h16" />
  </svg>
);

export const ChartIcon = (props: IconProps) => (
  <svg {...baseProps} {...props}>
    <path d="M3 20V10" />
    <path d="M9 20V4" />
    <path d="M15 20v-7" />
    <path d="M21 20V7" />
  </svg>
);

export const UserIcon = (props: IconProps) => (
  <svg {...baseProps} {...props}>
    <circle cx="12" cy="8" r="4" />
    <path d="M4 21a8 8 0 0 1 16 0" />
  </svg>
);

export const UsersIcon = (props: IconProps) => (
  <svg {...baseProps} {...props}>
    <circle cx="9" cy="8" r="3.4" />
    <path d="M3 20a6 6 0 0 1 12 0" />
    <path d="M16.5 5.3a3.4 3.4 0 0 1 0 6.4" />
    <path d="M17.5 14.4A6 6 0 0 1 21 20" />
  </svg>
);

export const CogIcon = (props: IconProps) => (
  <svg {...baseProps} {...props}>
    <circle cx="12" cy="12" r="3" />
    <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.6 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.6a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9c.14.62.66 1.05 1.29 1.05H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
  </svg>
);

export const PlayIcon = (props: IconProps) => (
  <svg {...baseProps} {...props}>
    <path d="M5 3l14 9-14 9z" fill="currentColor" stroke="none" />
  </svg>
);

export const FlameIcon = (props: IconProps) => (
  <svg {...baseProps} {...props}>
    <path d="M12 2c1 4 4 5 4 9a4 4 0 1 1-8 0c0-2 1-3 2-4-.2 2 .8 3 2 3 0-3-2-5 0-8z" />
  </svg>
);

export const SparklesIcon = (props: IconProps) => (
  <svg {...baseProps} {...props}>
    <path d="M12 3l1.7 4.6L18 9.3l-4.3 1.7L12 15.6l-1.7-4.6L6 9.3l4.3-1.7z" />
    <path d="M18.5 14l.8 2.2 2.2.8-2.2.8-.8 2.2-.8-2.2-2.2-.8 2.2-.8z" />
  </svg>
);

export const LibraryIcon = (props: IconProps) => (
  <svg {...baseProps} {...props}>
    <path d="M3 5h4v14H3z" />
    <path d="M9 5h4v14H9z" />
    <path d="M15.5 6.5l3.6-1 3.4 12.3-3.6 1z" />
  </svg>
);

/** Две карточки стопкой — раздел «Слова и модули» (модули и карточки). */
export const WordsIcon = (props: IconProps) => (
  <svg {...baseProps} {...props}>
    <rect x="8" y="8" width="12" height="12" rx="2.5" />
    <path d="M16 8V6.5A2.5 2.5 0 0 0 13.5 4h-7A2.5 2.5 0 0 0 4 6.5v7A2.5 2.5 0 0 0 6.5 16H8" />
  </svg>
);

/** Три точки — вкладка «Ещё» на телефоне. */
export const MoreIcon = (props: IconProps) => (
  <svg {...baseProps} {...props}>
    <circle cx="5" cy="12" r="1.8" fill="currentColor" stroke="none" />
    <circle cx="12" cy="12" r="1.8" fill="currentColor" stroke="none" />
    <circle cx="19" cy="12" r="1.8" fill="currentColor" stroke="none" />
  </svg>
);

/** Лупа — поиск по словарю (строка создания карточки на главной). */
export const SearchIcon = (props: IconProps) => (
  <svg {...baseProps} strokeWidth={1.8} {...props}>
    <circle cx="11" cy="11" r="6.5" />
    <path d="M20 20l-4.2-4.2" />
  </svg>
);

/** Геймпад в пиксельном духе — игра «Выживи в Лондоне» (вкладка меню и плитка на главной). */
export const GameIcon = (props: IconProps) => (
  <svg {...baseProps} strokeWidth={1.8} {...props}>
    <path d="M7 8h10a4 4 0 0 1 4 4v1.5a3.5 3.5 0 0 1-6.3 2.1L13.5 14h-3l-1.2 1.6A3.5 3.5 0 0 1 3 13.5V12a4 4 0 0 1 4-4Z" />
    <path d="M8 11v3M6.5 12.5h3M15.5 11.5h.01M17.5 13.5h.01" />
  </svg>
);

export const LightbulbIcon = (props: IconProps) => (
  <svg {...baseProps} {...props}>
    <path d="M9 18h6" />
    <path d="M10 21h4" />
    <path d="M12 3a6 6 0 0 0-3.6 10.8c.7.6 1.1 1.4 1.1 2.2h5c0-.8.4-1.6 1.1-2.2A6 6 0 0 0 12 3z" />
  </svg>
);

export const ChevronLeftIcon = (props: IconProps) => (
  <svg {...baseProps} strokeWidth={1.8} {...props}>
    <path d="M15 18l-6-6 6-6" />
  </svg>
);

export const ChevronRightIcon = (props: IconProps) => (
  <svg {...baseProps} strokeWidth={1.8} {...props}>
    <path d="M9 18l6-6-6-6" />
  </svg>
);

export const ChevronDownIcon = (props: IconProps) => (
  <svg {...baseProps} strokeWidth={1.8} {...props}>
    <path d="M6 9l6 6 6-6" />
  </svg>
);

export const SpeakerIcon = (props: IconProps) => (
  <svg {...baseProps} strokeWidth={1.8} {...props}>
    <path d="M11 5 6 9H2v6h4l5 4V5z" />
    <path d="M15.5 8.5a5 5 0 0 1 0 7" />
    <path d="M18.5 5.5a9 9 0 0 1 0 13" />
  </svg>
);

export const PlusIcon = (props: IconProps) => (
  <svg {...baseProps} strokeWidth={2} {...props}>
    <path d="M12 5v14M5 12h14" />
  </svg>
);

/** Подарок за подписку (боковая панель, ТЗ главной § 11). */
export const GiftIcon = (props: IconProps) => (
  <svg {...baseProps} {...props}>
    <rect x="3.5" y="8" width="17" height="4" rx="1" />
    <path d="M5 12v7.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V12" />
    <path d="M12 8v12.5" />
    <path d="M12 8c-1.6 0-4.5-.4-4.5-2.6C7.5 4 8.6 3.4 9.5 3.6 11 4 12 6.5 12 8z" />
    <path d="M12 8c1.6 0 4.5-.4 4.5-2.6 0-1.4-1.1-2-2-1.8C13 4 12 6.5 12 8z" />
  </svg>
);

/** Замок: строка создания закрыта, пока нет тарифа (ТЗ главной § 10). */
export const LockIcon = (props: IconProps) => (
  <svg {...baseProps} {...props}>
    <rect x="5" y="10.5" width="14" height="10" rx="2" />
    <path d="M8 10.5V7.5a4 4 0 0 1 8 0v3" />
  </svg>
);

export const CheckIcon = (props: IconProps) => (
  <svg {...baseProps} strokeWidth={2.4} {...props}>
    <path d="M5 12l5 5L20 7" />
  </svg>
);

export const ShieldIcon = (props: IconProps) => (
  <svg {...baseProps} {...props}>
    <path d="M12 3l7 3v5c0 4.5-3 7.6-7 9-4-1.4-7-4.5-7-9V6z" />
    <path d="M9.2 12l2 2 3.6-4" />
  </svg>
);

/** Телефон со стрелкой вниз — установка приложения на телефон. */
export const PhoneIcon = (props: IconProps) => (
  <svg {...baseProps} {...props}>
    <rect x="6" y="2.5" width="12" height="19" rx="2.5" />
    <path d="M12 7v6.5M9.5 11l2.5 2.5 2.5-2.5" />
    <path d="M10.5 18.5h3" />
  </svg>
);

export const BellIcon = (props: IconProps) => (
  <svg {...baseProps} {...props}>
    <path d="M18 8a6 6 0 0 0-12 0c0 7-3 9-3 9h18s-3-2-3-9" />
    <path d="M13.7 21a2 2 0 0 1-3.4 0" />
  </svg>
);

export const EyeIcon = (props: IconProps) => (
  <svg {...baseProps} {...props}>
    <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12z" />
    <circle cx="12" cy="12" r="3" />
  </svg>
);

export const EyeOffIcon = (props: IconProps) => (
  <svg {...baseProps} {...props}>
    <path d="M3 3l18 18" />
    <path d="M10.6 6.1A10 10 0 0 1 12 6c6.5 0 10 7 10 7a17 17 0 0 1-3.2 4.1" />
    <path d="M6.1 6.1A17 17 0 0 0 2 13s3.5 7 10 7a10 10 0 0 0 5.4-1.6" />
    <path d="M9.9 9.9a3 3 0 0 0 4.2 4.2" />
  </svg>
);

// Глифы соцсетей Lomora (моно, заливка currentColor): цвет бренда задаёт
// родитель — см. socialColors в shared/config/socials.ts.
export const TelegramIcon = (props: IconProps) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M9.78 18.65l.28-4.23 7.68-6.92c.34-.31-.07-.46-.52-.19L7.74 13.3 3.64 12c-.88-.25-.89-.86.2-1.3l15.97-6.16c.73-.33 1.43.18 1.15 1.3l-2.72 12.81c-.19.91-.74 1.13-1.5.71L12.6 16.3l-1.99 1.93c-.23.23-.42.42-.83.42z" />
  </svg>
);

export const VkIcon = (props: IconProps) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M13.16 16.5c-5.46 0-8.94-3.85-9.08-10.24h2.74c.1 4.7 2.21 6.69 3.86 7.1V6.26h2.6v3.93c1.64-.18 3.36-2.02 3.94-3.93h2.58c-.44 2.36-2.27 4.2-3.57 4.96 1.3.62 3.38 2.23 4.18 5.28h-2.85c-.62-1.92-2.2-3.4-4.28-3.61v3.61z" />
  </svg>
);

export const DzenIcon = (props: IconProps) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M12 2c.4 5.2 4.4 9.4 9.6 9.9v.2C16.4 12.6 12.4 16.8 12 22c-.4-5.2-4.4-9.4-9.6-9.9v-.2C7.6 11.4 11.6 7.2 12 2z" />
  </svg>
);

export const YandexIcon = (props: IconProps) => (
  <svg viewBox="0 0 24 24" {...props}>
    <rect width="24" height="24" rx="5" fill="#FC3F1D" />
    <path
      d="M13.4 6.9h-2.6c-1.7 0-3 1.3-3 3.2 0 1.4.7 2.4 1.7 2.9l-2 4.1h2L11.3 13h.6v4.1H14V6.9h-.6zm-1.5 4.4h-.7c-.9 0-1.5-.6-1.5-1.5s.6-1.5 1.5-1.5h.7v3z"
      fill="#fff"
    />
  </svg>
);
